// Globally register all base components for convenience, because they
// will be used very frequently. Components are registered using the
// PascalCased version of their file name.

import _upperFirst from 'lodash/upperFirst'
import _camelCase from 'lodash/camelCase'

const components = {};

// https://webpack.js.org/guides/dependency-management/#require-context
const requireComponent = require.context(
  // Look for files in the current directory
  '@dialog',
  // Do not look in subdirectories
  false,
  // Only include "_base-" prefixed .vue files
  // /Base[\w-]+\.vue$/
  /\.vue$/
);

// For each matching file name...
requireComponent.keys()
  .forEach((fileName) => {
    // Get the component config
    const componentConfig = requireComponent(fileName);
    // Get the PascalCase version of the component name
    const componentName = _upperFirst(
      _camelCase(
        fileName
          // Remove the "./_" from the beginning
          .replace(/^\.\//, '')
          // Remove the file extension from the end
          .replace(/\.\w+$/, '')
      )
    );
    // Globally register the component
    // Vue.component(componentName, componentConfig.default || componentConfig)
    components[componentName] = componentConfig.default || componentConfig
  });

export default components;
